// from gemini
// src/directives/tooltip.js
import { Tooltip } from "bootstrap"; // Import the Tooltip class from Bootstrap

export default {
  // `mounted` hook: Called when the bound element has been inserted into the DOM.
  // This is where we initialize the Bootstrap Tooltip instance.
  mounted(el, binding) {
    // Define default options or get them from the binding value/arguments
    const options = {
      animation: true,
      delay: 0, // Can be a number or { show: 500, hide: 100 }
      html: false, // Set to true to allow HTML in tooltip content
      placement: "top",
      trigger: "hover focus", // 'click', 'hover', 'focus', 'manual'
      container: false, // Or 'body' to prevent z-index issues in complex layouts
      customClass: "", // Your custom CSS class for styling
      title: "", // The tooltip content
      offset: [0, 0], // [skidding, distance]
      // Add any other Bootstrap 5 Tooltip options you wish to support
      // https://getbootstrap.com/docs/5.3/components/tooltips/#options
    };

    // Apply options based on the directive's value (e.g., v-tooltip="{ title: 'Hi', placement: 'bottom' }")
    if (typeof binding.value === "string") {
      options.title = binding.value;
    } else if (typeof binding.value === "object") {
      Object.assign(options, binding.value);
    }

    // Apply placement from directive argument (e.g., v-tooltip:right="'My tooltip'")
    if (binding.arg) {
      options.placement = binding.arg;
    }

    // Important: Bootstrap 5 allows defining options via data attributes (data-bs-*)
    // The Tooltip constructor automatically reads these if present.
    // So, we don't necessarily need to explicitly extract all of them here,
    // but you can if you want to prioritize directive values over data attributes.
    // For example, if you set data-bs-placement="bottom" and v-tooltip:top, the directive's arg will win.

    // Store the Tooltip instance on the element for later access (update/dispose)
    el._bsTooltip = new Tooltip(el, options);
  },

  // `updated` hook: Called after the component's DOM has been updated.
  // This is crucial for updating the tooltip if its title or options change reactively.
  updated(el, binding) {
    if (el._bsTooltip) {
      // If the tooltip's title changes, update it using Bootstrap's setContent method.
      // This is efficient and doesn't require re-initializing the entire tooltip.
      if (typeof binding.value === "string") {
        el._bsTooltip.setContent({ ".tooltip-inner": binding.value });
      } else if (
        typeof binding.value === "object" &&
        binding.value.title !== undefined
      ) {
        el._bsTooltip.setContent({ ".tooltip-inner": binding.value.title });
      }
      // For changes to other options (like placement, customClass, etc.), Bootstrap's Tooltip
      // doesn't have a direct `updateOptions` method. You would typically need to
      // dispose and re-initialize the tooltip for such changes to take effect.
      // However, for most use cases, the initial options are static or change infrequently.
    }
  },

  // `beforeUnmount` hook: Called right before the element is unmounted from the DOM.
  // This is critical for preventing memory leaks by disposing of the Bootstrap Tooltip instance.
  beforeUnmount(el) {
    if (el._bsTooltip) {
      el._bsTooltip.dispose(); // Destroy the Bootstrap Tooltip instance
      el._bsTooltip = null; // Clear the reference
    }
  },
};
